
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 6.59V5a3 3 0 00-2.5-2.955V1.5a.5.5 0 10-1 0v.545A3 3 0 003 5v1.59A1.5 1.5 0 002 8v1a.5.5 0 00.5.5h1.57a2 2 0 003.86 0H9.5A.5.5 0 0010 9V8a1.5 1.5 0 00-1-1.41zM4 5a2 2 0 114 0v1.5H4V5zm2 5a1 1 0 01-.86-.5h1.72A1 1 0 016 10zm3-1.5H3V8a.5.5 0 01.5-.5h5A.5.5 0 019 8v.5z","fill":"url(#paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"6","y1":"1","x2":"6","y2":"10.976","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#2E2406"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9E640D"}})])])])
          )
        }
      }
    